import { CheckIcon, CopyIcon } from 'lucide-react'
import { memo, useState } from 'react'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export interface ChatCopyButtonProps {
  content: string

  className?: string
}

const ChatCopyButtonBase: React.FC<ChatCopyButtonProps> = ({ content, className }) => {
  const [isCopied, setIsCopied] = useState(false)

  const handleCopy = async (e: React.MouseEvent): Promise<void> => {
    e.stopPropagation()
    try {
      await navigator.clipboard.writeText(content)
      setIsCopied(true)
      setTimeout(() => setIsCopied(false), 2000)
    } catch {
      // TODO: implement
    }
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn('size-7 text-muted-foreground hover:text-foreground', className)}
          onClick={handleCopy}
        >
          {isCopied ? <CheckIcon className="size-3.5" /> : <CopyIcon className="size-3.5" />}
          <span className="sr-only">{isCopied ? 'Copied' : 'Copy message'}</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top">{isCopied ? 'Copied!' : 'Copy'}</TooltipContent>
    </Tooltip>
  )
}

export const ChatCopyButton = memo(ChatCopyButtonBase)

ChatCopyButton.displayName = 'ChatCopyButton'
